// extracted by mini-css-extract-plugin
export default {"container":"InfoTooltip_container__iiAal"};